import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "subscription-error"
}
const _hoisted_4 = {
  key: 2,
  class: "ban-reason-section"
}
const _hoisted_5 = { class: "buttons-section" }

import {
    onMounted,
    onUnmounted,
    computed,
    ref,
    watch,
  } from 'vue';
  import ButtonAtom from './ButtonAtom.vue';
  import IconAtom from './IconAtom.vue';
  import { useStore } from 'vuex';

  type UserActionsModal = {
    title: string;
    message?: string;
    buttonPrimaryText: string;
    buttonSecondaryText: string;
  };
  
export default /*@__PURE__*/_defineComponent({
  __name: 'UserActionsModal',
  props: {
    show: Boolean,
    action: String,
  },
  emits: ['update:show', 'dispatch:action'],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const store = useStore();
  const selectedUser = computed(() => store.getters['user/getSelectedUser']);
  const banReason = ref('');
  const subscriptionError = ref('');
  const emits = __emit;

  const closeModal = () => {
    banReason.value = '';
    subscriptionError.value = '';
    emits('update:show', false);
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  };

  const modalContext = ref<UserActionsModal>({
    title: '',
    message: '',
    buttonPrimaryText: '',
    buttonSecondaryText: '',
  });

  const handleAction = () => {
    emits('dispatch:action', banReason.value);
    banReason.value = '';
    subscriptionError.value = '';
    closeModal();
  };

  const updateModalContext = () => {
    switch (props.action) {
      case 'delete':
        modalContext.value.title = `Are you sure you want to delete ${selectedUser.value.full_name}'s account?`;
        modalContext.value.message =
          'Account cannot be restored, only created again';
        modalContext.value.buttonPrimaryText = 'Yes, delete account';
        modalContext.value.buttonSecondaryText = 'No, keep account';
        break;

      case 'passwordReset':
        modalContext.value.title = `Do you want to send a password reset to ${selectedUser.value.name}?`;
        modalContext.value.message =
          'User will be able to reset their password';
        modalContext.value.buttonPrimaryText = 'Yes, send';
        modalContext.value.buttonSecondaryText = 'No';
        break;

      case 'ban':
        modalContext.value.title = `Are you sure you want to ban ${selectedUser.value.name} from all communities they joined?`;
        modalContext.value.message = '';
        modalContext.value.buttonPrimaryText = 'Yes, ban from community';
        modalContext.value.buttonSecondaryText = 'No';
        break;

      case 'unban':
        modalContext.value.title = `Are you sure you want to unban ${selectedUser.value.name}?`;
        modalContext.value.message = 'User will be able to access all communities again.';
        modalContext.value.buttonPrimaryText = 'Yes, unban user';
        modalContext.value.buttonSecondaryText = 'No';
        break;

      case 'notification':
        modalContext.value.title = `Are you sure you want to ban ${selectedUser.value.name} from all communities they joined?`;
        modalContext.value.message = '';
        modalContext.value.buttonSecondaryText = 'Cancel';
        modalContext.value.buttonPrimaryText = 'Send personal notification';
        break;

      default:
        modalContext.value.title = '';
        modalContext.value.message = '';
        modalContext.value.buttonPrimaryText = '';
        modalContext.value.buttonSecondaryText = '';
        break;
    }
  };

  watch(() => props.action, updateModalContext, { immediate: true });

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown);
  });

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyDown);
  });

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "delete-modal-overlay",
        onClick: closeModal
      }, [
        _createElementVNode("div", {
          class: "delete-modal",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h2", null, _toDisplayString(modalContext.value.title), 1),
            _createVNode(IconAtom, {
              class: "close-icon",
              icon: "closeIcon",
              onClick: closeModal
            }),
            (modalContext.value.message)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(modalContext.value.message), 1))
              : _createCommentVNode("", true),
            (subscriptionError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(subscriptionError.value), 1))
              : _createCommentVNode("", true),
            (__props.action === 'ban')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { for: "ban-reason" }, "Ban reason (visible to user):", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "ban-reason",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((banReason).value = $event)),
                    placeholder: "Enter the reason for banning this user...",
                    rows: "3",
                    class: "ban-reason-input"
                  }, null, 512), [
                    [_vModelText, banReason.value]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ButtonAtom, {
              class: "btn btn-primary",
              onClick: handleAction
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(modalContext.value.buttonPrimaryText), 1)
              ]),
              _: 1
            }),
            _createVNode(ButtonAtom, {
              class: "btn btn-secondary",
              onClick: closeModal
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(modalContext.value.buttonSecondaryText), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})